import { hbs } from 'ember-cli-htmlbars';
export default hbs("<label\n  id={{@guid}}\n  class=\'text-sm\'\n  ...attributes\n  data-test-headlessui-switch-label\n  {{on \'click\' @onClick}}\n>\n  {{yield}}\n</label>")